/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const kioskAuthButtonTypeEnumSchema = z
	.enum(["card", "scanner", "camera", "phone"])
	.describe(
		"* `card` - Физическая карта лояльности\n* `scanner` - Сканирование QR сканером штрихкодов\n* `camera` - Сканирование QR камерой устройства\n* `phone` - По номеру телефона",
	);
